export default {
  name: "ExhibitionMode",
  props: {
    name: {
      type: String,
      default: () => ""
    }
  }
};